import { midChores12_0 } from './12-0';
import { midChores12_1 } from './12-1';
import { midDelves } from './delves';
import { midPrey } from './prey';
import { midProfessions } from './professions';
import { midVeteranCaches } from './veteran-caches';

export const midTasks = [
    midVeteranCaches,
    midChores12_0,
    midChores12_1,
    midDelves,
    midPrey,
    midProfessions,
];
